import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'energy_management_system'

export const dataPointDefinition = {
  retracedId: 'energy_management_system',
  name: 'Energy Management System',
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 630,
  sectionId: '2.1.6.1',
  impactArea: 'Energy sources',
  impactAreaId: 'ENERGY_SOURCES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
